module.exports = __webpack_public_path__ + "static/media/ZOE.3c8f60da.svg";